class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search-results') || this;
    this.cachedResults = {};
    this.searchTerm = '';
    this.isOpen = false;
    this.abortController = new AbortController();

    if (!this.input) return;

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.addEventListener('input', this.debounce((event) => {
      const newSearchTerm = this.input.value.trim();
      this.onChange(newSearchTerm);
    }, 300).bind(this));

    this.input.addEventListener('focus', () => {
      if (this.input.value.length) this.onChange(this.input.value.trim());
    });

    // this.addEventListener('focusout', (event) => {
    //   setTimeout(() => {
    //     if (!this.contains(document.activeElement)) this.close();
    //   }, 100);
    // });
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  onChange(searchTerm) {
    if (searchTerm === this.searchTerm) return;
    this.searchTerm = searchTerm;

    if (!searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(/\s+/g, '-').toLowerCase();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    this.setLoadingState(true);

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`, {
      signal: this.abortController.signal
    })
      .then(response => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(text => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#predictive-search-results')?.innerHTML || '';

        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      })
      .catch(err => {
        if (err.name === 'AbortError') return;
        this.close();
      });
  }

  setLoadingState(loading) {
    if (loading) {
      this.setAttribute('loading', 'true');
    } else {
      this.removeAttribute('loading');
    }
  }

  renderSearchResults(resultsMarkup) {
    // Replace the content of #predictive-search-results (our custom one)
    const resultsContainer = document.getElementById('predictive-search-results');
    if (resultsContainer) {
      resultsContainer.innerHTML = resultsMarkup;
    }

    this.setLoadingState(false);
    this.open();
  }

  open() {
    if (this.isOpen) return;
    this.isOpen = true;
    this.setAttribute('open', 'true');
    this.input.setAttribute('aria-expanded', 'true');

    // Force keep dropdown open even after typing stops
    const resultsContainer = document.getElementById('predictive-search-results');
    if (resultsContainer && resultsContainer.children.length > 0) {
      this.style.display = 'block';
      this.predictiveSearchResults.style.display = 'block';
    }
  }

  close(clearSearch = false) {
    if (clearSearch) {
      this.input.value = '';
      this.searchTerm = '';
    }

    this.isOpen = false;
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', 'false');
    this.setLoadingState(false);

    // Only actually hide if no results exist
    const resultsContainer = document.getElementById('predictive-search-results');
    // if (resultsContainer && resultsContainer.children.length === 0) {
    //   this.style.display = 'none';
    // }
  }
}

customElements.define('predictive-search', PredictiveSearch);